// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.___song_detail {
  padding: 0 20px 100px 20px;
}
@media (max-width: 576px) {
  .___song_detail {
    padding: 0 20px;
  }
}
.___song_detail .___song_detail_box {
  width: 60%;
  padding-bottom: 100px;
  position: relative;
}
@media screen and (max-width: 1200px) {
  .___song_detail .___song_detail_box {
    width: 100%;
    padding-left: 0;
  }
}
@media (max-width: 576px) {
  .___song_detail .___song_detail_box {
    width: 100%;
    padding-left: 0;
  }
}
.___song_detail .___song_detail_box .___song_detail_container {
  position: relative;
}
@media screen and (max-width: 1245px) {
  .___song_detail .___song_detail_box .___song_detail_container .___song_detail_banner .___song_detail_banner_detail .__shareRow {
    flex-direction: column;
    align-items: flex-start;
  }
  .___song_detail .___song_detail_box .___song_detail_container .___song_detail_banner .___song_detail_banner_detail .__shareRow:last-child {
    margin-left: 0px !important;
  }
}
@media screen and (max-width: 1090px) {
  .___song_detail .___song_detail_box .___song_detail_container .___song_detail_banner .___song_detail_banner_detail {
    flex-direction: column;
  }
  .___song_detail .___song_detail_box .___song_detail_container .___song_detail_banner .___song_detail_banner_detail .__shareRow {
    flex-direction: row;
    align-items: center;
  }
  .___song_detail .___song_detail_box .___song_detail_container .___song_detail_banner .___song_detail_banner_detail .__shareRow:last-child {
    margin-left: 0px !important;
  }
}
@media (max-width: 576px) {
  .___song_detail .___song_detail_box .___song_detail_container .___song_detail_banner .___song_detail_banner_detail {
    flex-direction: column;
  }
  .___song_detail .___song_detail_box .___song_detail_container .___song_detail_banner .___song_detail_banner_detail ._img_large {
    margin: auto;
  }
}
.___song_detail .___song_detail_box .___song_detail_more .___buy_option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #090909;
  border-radius: 16px;
  padding: 16px 20px;
  min-height: 82px;
}
@media (max-width: 576px) {
  .___song_detail .___song_detail_box .___song_detail_more .___buy_option {
    flex-direction: column;
    gap: 20px;
  }
}

.float {
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
  border-radius: 15px;
  background: transparent linear-gradient(180deg, #171515 0%, #070606 100%) 0% 0% no-repeat padding-box;
}
@media screen and (max-width: 768px) {
  .float {
    width: 100%;
  }
}
@media (max-width: 576px) {
  .float {
    width: 100%;
  }
}

.overall {
  column-gap: 24px;
  display: flex;
  width: 100%;
}
@media screen and (max-width: 768px) {
  .overall {
    flex-direction: column;
  }
}
@media screen and (max-width: 992px) {
  .overall {
    width: 120%;
  }
}
@media (max-width: 576px) {
  .overall {
    flex-direction: column;
  }
}

.__back_cover_Music_nft {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  z-index: -1;
  filter: blur(3px);
  opacity: 0.7;
  height: inherit;
  margin-top: 0;
}
.__back_cover_Music_nft img {
  object-fit: cover;
}
.__back_cover_Music_nft ._cover_shadow {
  height: 60px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: transparent linear-gradient(180deg, rgba(16, 16, 15, 0) 0%, #1E1E1E 100%) 0% 0% no-repeat padding-box;
}
@media (max-width: 576px) {
  .__back_cover_Music_nft {
    width: 140vw;
  }
}

._nft_multi_artist {
  display: grid !important;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  overflow: scroll;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/pages/SongDetail/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BA;EACI,0BAAA;AA4BJ;ADME;ECnCF;IAIQ,eAAA;EA6BN;AACF;AA3BI;EACI,UAAA;EACA,qBAAA;EACA,kBAAA;AA6BR;AA3BQ;EALJ;IAMQ,WAAA;IACA,eAAA;EA8BV;AACF;ADVE;EC5BE;IAWQ,WAAA;IACA,eAAA;EA+BV;AACF;AA7BQ;EACI,kBAAA;AA+BZ;AAxBoB;EACI;IACI,sBAAA;IACA,uBAAA;EA0B1B;EAxB0B;IACI,2BAAA;EA0B9B;AACF;AAtBoB;EAbJ;IAcQ,sBAAA;EAyBtB;EAvBsB;IACI,mBAAA;IACA,mBAAA;EAyB1B;EAvB0B;IACI,2BAAA;EAyB9B;AACF;ADxCE;ECPc;IA2BQ,sBAAA;EAwBtB;EArBkB;IAEQ,YAAA;EAwB1B;AAJF;AAZY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAmBhB;AD3DE;ECiCU;IAUQ,sBAAA;IACA,SAAA;EAoBlB;AACF;;AAdA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,qGAAA;AAiBJ;AAfI;EATJ;IAUQ,WAAA;EAkBN;AACF;ADhFE;ECmDF;IAcQ,WAAA;EAmBN;AACF;;AAhBA;EACI,gBAAA;EACA,aAAA;EACA,WAAA;AAmBJ;AAjBI;EALJ;IAMQ,sBAAA;EAoBN;AACF;AAlBI;EATJ;IAUQ,WAAA;EAqBN;AACF;ADrGE;ECqEF;IAcQ,sBAAA;EAsBN;AACF;;AAnBA;EACI,kBAAA;EACI,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAsBR;AApBQ;EACI,iBAAA;AAsBZ;AAnBQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iHAAA;AAqBZ;ADnIE;ECuFF;IA2BY,YAAA;EAqBV;AACF;;AAlBA;EACI,wBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAqBJ","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n\n.___song_detail {\n    padding: 0 20px 100px 20px;\n\n    @include sm {\n        padding: 0 20px;\n    }\n\n    .___song_detail_box {\n        width: 60%;\n        padding-bottom: 100px;\n        position: relative;\n\n        @media screen and (max-width:1200px) {\n            width: 100%;\n            padding-left: 0;\n        }\n\n        @include sm {\n            width: 100%;\n            padding-left: 0;\n        }\n\n        .___song_detail_container {\n            position: relative;\n\n            .___song_detail_banner {\n\n\n                .___song_detail_banner_detail {\n\n                    @media screen and (max-width:1245px) {\n                        .__shareRow {\n                            flex-direction: column;\n                            align-items: flex-start;\n\n                            &:last-child {\n                                margin-left: 0px !important;\n                            }\n                        }\n                    }\n\n                    @media screen and (max-width:1090px) {\n                        flex-direction: column;\n\n                        .__shareRow {\n                            flex-direction: row;\n                            align-items: center;\n\n                            &:last-child {\n                                margin-left: 0px !important;\n                            }\n                        }\n                    }\n\n                    @include sm {\n                        flex-direction: column;\n                    }\n\n                    ._img_large {\n                        @include sm {\n                            margin: auto;\n                        }\n                    }\n                }\n            }\n        }\n\n        .___song_detail_more {\n            .___buy_option {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                background-color: #090909;\n                border-radius: 16px;\n                padding: 16px 20px;\n                min-height: 82px;\n\n                @include sm {\n                    flex-direction: column;\n                    gap: 20px;\n                }\n            }\n        }\n    }\n}\n\n.float {\n    height: 300px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 40%;\n    border-radius: 15px;\n    background: transparent linear-gradient(180deg, #171515 0%, #070606 100%) 0% 0% no-repeat padding-box;\n\n    @media screen and (max-width: 768px) {\n        width: 100%;\n    }\n\n    @include sm {\n        width: 100%;\n    }\n}\n\n.overall {\n    column-gap: 24px;\n    display: flex;\n    width: 100%;\n\n    @media screen and (max-width: 768px) {\n        flex-direction: column;\n    }\n\n    @media screen and (max-width: 992px) {\n        width: 120%;\n    }\n\n    @include sm {\n        flex-direction: column;\n    }\n}\n\n.__back_cover_Music_nft{\n    position: absolute;\n        top: 0;\n        right: 0;\n        left: 0;\n        bottom: 0;\n        margin: auto;\n        text-align: center;\n        z-index: -1;\n        filter: blur(3px);\n        opacity: 0.7;\n        height: inherit;\n        margin-top: 0;\n    \n        img {\n            object-fit: cover;\n        }\n    \n        ._cover_shadow {\n            height: 60px;\n            width: 100%;\n            position: absolute;\n            bottom: 0;\n            background: transparent linear-gradient(180deg, #10100F00 0%, #1E1E1E 100%) 0% 0% no-repeat padding-box;\n        }\n    \n        @include sm {\n            width: 140vw;\n        }\n}\n\n._nft_multi_artist{\n    display: grid !important;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    overflow: scroll;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
